module.exports = __webpack_public_path__ + "img/My project copiar-1.9e56e361.png";